import React, { useContext } from 'react';
import useStyles from './useStyles';
import { SMFooterContext } from '../SMFooterContext';

const CopyRight = () => {
  const { isPrivateLabel } = useContext(SMFooterContext);
  const { copyRight } = useStyles();

  const year = new Date().getFullYear();

  return (
    <Choose>
      <When condition={!!isPrivateLabel}>
        <span className={copyRight}>{`Copyright © ${year} Momentive`}</span>
      </When>
      <Otherwise>
        <span className={copyRight}>
          {`Copyright © 1999-${year} Momentive`}
        </span>
      </Otherwise>
    </Choose>
  );
};

export default CopyRight;
